import React from "react";
import { projectDataSummary } from "data";
import ProjectGallery from "Parts/ProjectGallery/ProjectGallery";
import { Fade } from "motion";
import { Text } from "foundation";
import { Flex } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { responsivePadding } from "Outlets/MainOutlet";

interface HeaderTextProps {
  title: string;
  subtitle: string;
  isItalic?: boolean;
}

const HeaderText = ({ title, subtitle, isItalic = false }: HeaderTextProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${title.toLowerCase()}`);
  };

  return (
    <Flex align="flex-end" gap="1rem">
      <Text
        textStyle="h1"
        fontStyle={isItalic ? "italic" : "normal"}
        clickable
        onClick={handleClick}
      >
        {title}
      </Text>
      <Text textStyle="h4" paddingBottom="0.4rem">
        {subtitle}
      </Text>
    </Flex>
  );
};

const HomePage: React.FC = () => {
  return (
    <Fade>
      <Flex gap="2rem" direction="column">
        <Flex paddingX={responsivePadding} paddingBottom={responsivePadding}>
          <Flex paddingY="2rem" direction="column">
            <HeaderText title="Coding" subtitle="Full-Time" />
            <HeaderText title="Photography" subtitle="Pastime" isItalic />
            <HeaderText title="Design" subtitle="Once Upon A Time" />
          </Flex>
        </Flex>

        <ProjectGallery projects={projectDataSummary} limit={9} />
      </Flex>
    </Fade>
  );
};

export default HomePage;
